import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69f64285f6558f0014d36540_1781550695226_f7819790/detailbook/src/app/faq/page.tsx");
